module.exports = __webpack_public_path__ + "static/img/qikan-1.5ddaea9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/qikan-1.jpg
// module id = L8oY
// module chunks = 46